import { render, staticRenderFns } from "./case.form.vue?vue&type=template&id=0f12e506&"
import script from "./case.form.vue?vue&type=script&lang=js&"
export * from "./case.form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports